import React, {PropTypes} from 'react';
import {connect} from 'react-redux';


// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class EducationMetal extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {}
	}

	componentDidMount() {
    document.title = 'Diamonds Direct - Education';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className={'EducationMetal EducationPage'}>
      <div className='eduHeader'>Metals of Fine Jewelry</div>
      <div className='eduBody'>
        <div className='topSection'>
          <div className='topImgBlock'>
            <img src='https://ddw2.diamondsdirect.com/img/education/metals/top.jpg' />
          </div>
          <div className='topTextBlock'>
            <div className='ttP'>In today's jewelry industry, there are many different types of metals commonly used in manufacturing jewelry. It is important to understand the differences between each metal when choosing an engagement ring or wedding band.</div>
            <div className='ttP'>In a diverse market, the metal types are commonly split up into two families- the precious metal family and the alternative metal family. The precious metal family includes platinum, gold, and palladium and is most noted for its inherent value and durability. The most intrinsically valued of these metals is platinum.</div>
            <div className='ttLink' onClick={() => this.externalNav('gallery/fine-jewelry?type=ring,earring,bracelet,necklace')}>Shop Fine Jewelry &gt;</div>
          </div>
        </div>
        <div className='metalsSection'>
          <div className='metalsWrapper'>
            <div className={'metalItem imgRight'}>
              <div className='miImgWrapper'>
                <img src='https://ddw2.diamondsdirect.com/img/education/metals/platinum-a.png' />
              </div>
              <div className='miTextWrapper'>
                <div className='miElemNumber'>78</div>
                <div className='miElemSymbol'>Pt</div>
                <div className='miTitle'>Platinum</div>
                <div className='miP'>Platinum is a naturally white metal that maintains its white color and finish for a lifetime. Platinum is also a hypoallergenic metal because few alloys are used to make the metal jewelry quality. Platinum reigns supreme in the jewelry industry because it is a solid, heavy metal that will maintain its density for generations.</div>
                <div className='miP'>Though platinum is dense, it is still very malleable- which works in the ring's favor. When a platinum ring is polished, bumped, dropped, or nicked, the platinum simply moves to the side, and can be polished back into place to look good as new. Many jewelers refer to platinum as ‘heirloom quality' for this reason.</div>
              </div>
            </div>
            <div className={'metalItem imgLeft'}>
              <div className='miImgWrapper'>
                <img src='https://ddw2.diamondsdirect.com/img/education/metals/gold-a.png' />
              </div>
              <div className='miTextWrapper'>
                <div className='miElemNumber'>79</div>
                <div className='miElemSymbol'>Au</div>
                <div className='miTitle'>Gold</div>
                <div className='miP'>Gold is a precious metal that is naturally yellow. It comes from the earth as a very soft metal and is mixed with alloys to make it hard enough to use in jewelry design. The ratio of gold to alloys is denoted by the karat measurement. For example, 24 karat gold is pure gold, 18 karat gold is 75% pure gold and 14 karat gold is about 58.33% pure gold.</div>
                <div className='miP'>By mixing in various alloys, gold can also be made to appear different colors such as black, green, red, and most commonly white. White gold gets its white tint by combining yellow gold with alloys like palladium, nickel, and zinc. A white gold piece of jewelry is also dipped in rhodium once it is polished and completed. This is what makes a white gold piece of jewelry rival a platinum piece. Through time, it is common for the rhodium plating to wear off the surface of the ring and to reveal a more yellow patina. A white gold ring can be re-dipped in rhodium easily and often to help maintain its white finish.</div>
              </div>
            </div>
            <div className={'metalItem imgRight'}>
              <div className={'miImgWrapper'}>
                <img src='https://ddw2.diamondsdirect.com/img/education/metals/palladium-a.png' />
              </div>
              <div className='miTextWrapper'>
                <div className='miElemNumber'>46</div>
                <div className='miElemSymbol'>Pd</div>
                <div className='miTitle'>Palladium</div>
                <div className='miP'>Palladium is an element found in the family of platinum group metals. For that reason, palladium has similar characteristics to platinum. One similarity is color, as palladium is a naturally white metal and will maintain this color for a lifetime. Palladium is also hypoallergenic like platinum. Palladium's primary difference from platinum is an important one- it is far less dense. For that reason, it is not recommended to use palladium when setting diamonds with prongs alone. Palladium's most common use within our industry is to create men's wedding bands.</div>
              </div>
            </div>
          </div>
        </div>
        <div className='altSection'>
          <div className='asTitle'>ALTERNATIVE METALS</div>
          <div className='asP'>Alternative metals are unique because these metal types are commonly used in other applications outside the jewelry industry like machinery, surgical tools, and artificial joint replacements. Within the jewelry industry - alternative metals are most commonly used in men's wedding bands.</div>
          <div className='asP'>One of the most noted distinctions from the precious metal family is cost, as alternative metals cost far less than precious metals. This is because alternative metals are not made from materials that are considered valuable commodities. In jewelry design, the most commonly used alternative metals are tungsten carbide, titanium, and cobalt.</div>
          <div className='asP'>Tungsten carbide, titanium, and cobalt all share similar characteristics. They are very hard, scratch resistant, shiny, light grey metals. Most are also hypoallergenic. Because of these characteristics, these alternative metals do not require much maintenance. Alternatively, due to hardness, these rings cannot be sized or engraved. They can also be very brittle and have been known to chip, crack, or shatter when dropped or slammed against a hard surface.</div>
          <div className='asP'>Regardless of certain risks in choosing a ring made of an alternative metal, Diamonds Direct works only with the most reputable wedding band designers who stand behind their product. These designers will provide you with a lifetime guarantee that will cover you if a ring needs to be exchanged due to sizing or exterior damage.</div>
          <div className='asLink' onClick={() => this.externalNav('gallery/wedding-bands/mens')}>Shop Men's Bands &gt;</div>
        </div>
      </div>
		</div>;
	}
}
export default EducationMetal;

function mapStateToProps(state) {
  return {

  };
}

export const EducationMetalContainer = connect(
  mapStateToProps,
  allActionCreators
)(EducationMetal);


// WEBPACK FOOTER //
// ./src/components/views/education/EducationMetal.jsx